class DrawerComponent extends HTMLElement {
  constructor() {
    super();

    const componentId = this.id;
    const drawerId = componentId.replace('-component', '');

    this.drawer = this.querySelector(`#${drawerId}-drawer`);
    this.drawerOverlay = this.querySelector(`#${drawerId}-overlay`);
    this.header = document.querySelector('sticky-header');
    this.activeElement = null;

    if (!this.drawer || !this.drawerOverlay) {
      return;
    }

    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.querySelectorAll('.drawer__close').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open(options = {}) {
    console.log('open', this);
    if (!this.drawer || !this.drawerOverlay) {
      return;
    }

    const { activeElement = null } = options;

    this.activeElement = activeElement || document.activeElement;

    this.drawer.classList.add('active');
    this.drawerOverlay.classList.add('show');

    document.body.style.overflow = 'hidden';

    this.drawer.addEventListener('transitionend', () => {
      this.drawer.focus();
      if (typeof trapFocus === 'function') {
        trapFocus(this.drawer);
      }
    }, { once: true });

    this.drawerOverlay.addEventListener('click', (evt) => {
      this.close();
    });

    this.announceToScreenReader('Drawer opened');
  }

  close() {
    if (!this.drawer || !this.drawerOverlay) {
      return;
    }

    this.drawer.classList.remove('active');
    this.drawerOverlay.classList.remove('show');

    document.body.style.overflow = '';

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    } else {
      if (this.activeElement && typeof this.activeElement.focus === 'function') {
        this.activeElement.focus();
      }
    }

    this.announceToScreenReader('Drawer closed');
  }



  announceToScreenReader(message) {
    let liveRegion = document.getElementById('drawer-live-region');
    if (!liveRegion) {
      liveRegion = document.createElement('div');
      liveRegion.id = 'drawer-live-region';
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.setAttribute('aria-atomic', 'true');
      liveRegion.style.position = 'absolute';
      liveRegion.style.left = '-10000px';
      liveRegion.style.width = '1px';
      liveRegion.style.height = '1px';
      liveRegion.style.overflow = 'hidden';
      document.body.appendChild(liveRegion);
    }

    liveRegion.textContent = message;

    setTimeout(() => {
      liveRegion.textContent = '';
    }, 1000);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  isOpen() {
    return this.drawer.classList.contains('active');
  }

  toggle() {
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }
}

customElements.define('drawer-component', DrawerComponent); 